import { useCallback } from 'react'
import { useAct } from 'FlowTaker/store'
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';

export default function CheckoutPage({ amountInMinorUnits, onComplete, isMonthly, coverFee, stripePromise }) {
    const act = useAct()
    const stripeSessionId = useRef(null)
    const fetchClientSecret = useCallback(() => {
      return act.taker.createStripeCheckoutSession({ amountInMinorUnits, isMonthly, coverFee })
        .then(({ data }) => {
          stripeSessionId.current = data.sessionId

          return data.clientSecret
        })
    }, []);

    const options = { fetchClientSecret, onComplete: v => onComplete({ stripeSessionId: stripeSessionId.current }) };

    return (
      <div id="checkout">
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={options}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    )
  }
